import { Box, Link as MuiLink, Stack } from '@mui/material';
import { useLocationForm } from 'components/forms/location/location-form.hooks';
import { IncAlert } from 'components/inc-alert/inc-alert.component';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

const HoursAlert = () => {
  const { t } = useTranslation();

  const { locationId } = useParams();
  const { data } = useLocationForm(locationId);

  return (
    <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2}>
      {!data?.ordering?.pickupOrdersAccepted && (
        <IncAlert
          severity="info"
          title={t(
            'page.locations.edit.tabs.ordering.sections.hours.alert.pickup.title',
          )}
          description={
            <>
              <Box>
                {t(
                  'page.locations.edit.tabs.ordering.sections.hours.alert.pickup.description.part1',
                )}
              </Box>
              <MuiLink component={Link} to="../../pickup" color="secondary">
                {t(
                  'page.locations.edit.tabs.ordering.sections.hours.alert.pickup.description.link',
                )}
              </MuiLink>
              {t(
                'page.locations.edit.tabs.ordering.sections.hours.alert.pickup.description.part2',
              )}
            </>
          }
          data-testid="Pickup.Alert"
        />
      )}
      {!data?.ordering?.deliveryOrdersAccepted && (
        <IncAlert
          severity="info"
          title={t(
            'page.locations.edit.tabs.ordering.sections.hours.alert.delivery.title',
          )}
          description={
            <>
              <Box>
                {t(
                  'page.locations.edit.tabs.ordering.sections.hours.alert.delivery.description.part1',
                )}
              </Box>
              <MuiLink component={Link} to="../../delivery" color="secondary">
                {t(
                  'page.locations.edit.tabs.ordering.sections.hours.alert.delivery.description.link',
                )}
              </MuiLink>
              {t(
                'page.locations.edit.tabs.ordering.sections.hours.alert.delivery.description.part2',
              )}
            </>
          }
          data-testid="Delivery.Alert"
        />
      )}
    </Stack>
  );
};

export default HoursAlert;
